import { local } from '@/db/repositories/local'
import * as shifts from '@/db/repositories/shifts'

/** Shifts live on the device only (POS.md §15.2); the demo API has none, so the demo hides the Shift screen. */
export const ShiftModel = {
  getCurrent: () =>
    local(shifts.getOpenShift().then(async (shift) => (shift ? shifts.summarise(shift) : null))),
  open: (openingBalance: number) => local(shifts.openShift(openingBalance)),
  recordCash: (type: 'cash_in' | 'cash_out', amount: number, remark?: string) =>
    local(shifts.recordCash(type, amount, remark)),
  close: (closingBalance: number) => local(shifts.closeShift(closingBalance)),
}
